// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__WGTpU","containerItemsCenter":"Skeleton_containerItemsCenter__3fNXK"};